import { Directive, ElementRef, NgZone, OnDestroy, inject, signal } from '@angular/core';

/**
 * Exposes the host element's content height as a signal.
 * Attach to an element whose height is set by its parent grid, never by its
 * children — measuring a content-sized element causes a resize feedback loop.
 */
@Directive({
  selector: '[isgSizer]',
  standalone: true,
  exportAs: 'isgSizer'
})
export class IsgSizerDirective implements OnDestroy {

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly zone = inject(NgZone);

  private readonly measured = signal<number>(0);

  /** Current content height of the host element, in whole pixels. */
  public readonly height = this.measured.asReadonly();

  private readonly observer = new ResizeObserver(entries => {

    const rect = entries[0]?.contentRect;

    if (!rect) {
      return;
    }

    const next = Math.floor(rect.height);

    this.zone.run(() => this.measured.set(next));
  });

  constructor() {

    this.observer.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {

    this.observer.disconnect();
  }
}
